// extracted by mini-css-extract-plugin
export default {"box":"model-status_box__nRU6P"};